import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogContainerComponent } from './dialog-container.component';
import { InsertionDirective } from './insertion.directive';
import { CpIconModule } from '../cp-icon/cp-icon.module';

/**
 * Source: https://malcoded.com/posts/angular-dynamic-components
 * Similar in design as Material Design's Dialog System.
 */
@NgModule({
  declarations: [DialogContainerComponent, InsertionDirective],
  imports: [CommonModule, CpIconModule],
  entryComponents: [DialogContainerComponent],
})
export class CpDialogModule {}
